<div class="avatar-big-container">
    <div class="app-top-nav__avatar-big" [ngStyle]="{'background': theme?.backgroundColor, 'color': theme?.textColour}"
        fxFlex="0 1 auto">
        {{userInfo?.initials}}
    </div>
    <div class="app-top-nav__lock-icon-big" *ngIf="isAdmin">
        <img width="8.89" height="11.67" src="../../../../assets/icons/lock_white.svg">
    </div>
</div>